'use client';

import { Box, Flex, Text, IconButton, Image } from '@chakra-ui/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { useState, useRef } from 'react';

const GetProgramFeatureList = ({ features }) => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const swiperRef = useRef(null);

  const handleSlideChange = swiper => {
    setIsBeginning(swiper.isBeginning);
    const isAtEnd =
      swiper.isEnd ||
      Math.ceil(swiper.translate) <= Math.ceil(swiper.maxTranslate());
    setIsEnd(isAtEnd);
  };

  const handlePrevClick = e => {
    e.stopPropagation();
    e.preventDefault();
    swiperRef.current?.slidePrev();
  };

  const handleNextClick = e => {
    e.stopPropagation();
    e.preventDefault();
    swiperRef.current?.slideNext();
  };

  return (
    <Box
      position="relative"
      bg="white"
      w="full"
      py={'12px'}
      px={'8px'}
      overflow={'hidden'}
    >
      {!isBeginning && (
        <IconButton
          aria-label="Previous"
          icon={<HiChevronLeft color="#1D1A16" />}
          onClick={handlePrevClick}
          position="absolute"
          top="0"
          left="0"
          height={'100%'}
          zIndex={2}
          bg="white"
          _hover={{ bg: 'white' }}
        />
      )}

      <Swiper
        modules={[Navigation]}
        slidesPerView={'auto'}
        spaceBetween={0}
        watchOverflow={true}
        watchSlidesProgress={true}
        onSwiper={swiper => {
          swiperRef.current = swiper;
          handleSlideChange(swiper);
        }}
        onSlideChange={handleSlideChange}
        onReachEnd={() => setIsEnd(true)}
        onFromEdge={() => {
          if (swiperRef.current) {
            setIsBeginning(swiperRef.current.isBeginning);
            setIsEnd(swiperRef.current.isEnd);
          }
        }}
        style={{ overflow: 'visible' }}
      >
        {!!features?.length &&
          features?.map((f, i) => {
            return (
              <SwiperSlide key={`${Date.now()}${i}`} style={{ width: 'auto' }}>
                <Flex
                  flexDirection="column"
                  py={1}
                  px={2}
                  maxW="106px"
                  w="100%"
                  gap={2}
                  justify="start"
                  align="center"
                >
                  <Image
                    key={i}
                    src={f?.image}
                    alt={`img-${i}`}
                    w="16px"
                    h="16px"
                    objectFit="contain"
                    display="block"
                  />
                  <Text
                    fontSize={{ base: '12px', md: '14px' }}
                    color="#1D1A16"
                    lineHeight={{ base: '14.4px', md: '16.8px' }}
                    w="full"
                    fontFamily="FedraSansStd-book"
                    textAlign="center"
                    minW="46px"
                  >
                    {f?.label}
                  </Text>
                </Flex>
              </SwiperSlide>
            );
          })}
      </Swiper>

      {!isEnd && (
        <IconButton
          aria-label="Next"
          icon={<HiChevronRight color="#1D1A16" />}
          onClick={handleNextClick}
          position="absolute"
          top="0"
          right="0"
          height={'100%'}
          zIndex={2}
          bg="white"
          _hover={{ bg: 'white' }}
        />
      )}
    </Box>
  );
};

export default GetProgramFeatureList;
